var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDownloadingError = function SvgIconDownloadingError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30 69.245c0-7.498 8.333-12.184 15-8.436 3.095 1.741 5 4.956 5 8.436 0 7.498-8.334 12.185-15 8.435-3.094-1.739-5-4.955-5-8.435m.979-58.491c-.73-6.748 6.312-11.737 12.678-8.98 3.585 1.553 5.735 5.179 5.323 8.98l-3.5 34.16c-.443 4.123-5.303 6.235-8.748 3.799a5.36 5.36 0 0 1-2.253-3.799z"
  })));
};
export default SvgIconDownloadingError;